import React from 'react'
import { useNavigate } from 'react-router-dom';

import imageOne from '../../resource/donations/healthfound/2.png'
import imageTwo from '../../resource/donations/healthfound/3.png'
import imageFour from '../../resource/donations/healthfound/4.png'
import imageThree from '../../resource/donations/healthfound/1.png'
import imageseven from '../../resource/donations/healthfound/image.jpg'
import imageSix from '../../resource/donations/healthfound/5 (3).png'
import TitleChnage from '../../Hook/TitleChnage'

const HealthFounds = () => {
    TitleChnage("Health Founds")
    const navigate = useNavigate();
        
    const handleClick = (event) => {

        const pathMap = {
            healthFundReq : '/healthFundReq',
        }
    
        const path = event.currentTarget.id;
        const targetPath = pathMap[path]
    
        if (targetPath){
          navigate(targetPath)
        }
      }
  return (
    <div className="healthfound-page inside-pages">
            <div className="right-box">
                <img src={imageOne} alt="Right Top Image" className="right-image" width={300} />
            </div>

            <h1 className='font-main p-4 mt-4'>Sangha Health Fund </h1>

            <p className="mt-6 h4 p-4">The Health Fund at Bhaddeka Vihari Monastery and Meditation Centre has been established to ensure the well-being and care of the Sangha residing at the Monastery, particularly in times of illness. With many Sangha members living on the premises, this fund is essential for providing medical care and support for Sangha during periods of sickness.</p>
            <p className="mt-5 h4 p-4">The Buddha’s words,  "Yo gilanam upattheyya, so man upattheyya" – “If you take care of the sick, you take care of me,” emphasize the profound importance of caring for those who are unwell. This compassionate act of care has been historically embraced, with many monasteries establishing dedicated sections for the treatment of sick monks.</p>
            <p className="mt-5 h4 p-4">Supporting the Sangha Health Fund is a meaningful opportunity to express gratitude and respect for the Sangha, who are the foundation of the Dhamma and spiritual practice. Their well-being is essential for maintaining the continuity of the teachings. By contributing, you are supporting the health and vitality of those who dedicate their lives to spiritual cultivation.</p>

            <p className="mt-5 h4 p-4">If you wish to make a monetary donation to the Health Fund, please use the available payment option.</p>

            <div className="text-center mt-6 h4 p-4">
                <div>
                    <p >“Yo gilanam upattheyya, so man upattheyya” </p>
                    <p >“If you take care of the sick, you take care of me.” — Buddha’s words</p>



                </div>
            </div>

            

    
        <img src={imageseven} alt="image" style={{ width: "100%" }} className='image-healthfound mt-6'/>

        <p className="mt-5 h4 p-4">The story of Putigatta Tissa Thera is a powerful example of the Buddha’s compassionate care for the sick. Tissa, a monk who suffered from a severe skin disease, was abandoned by his fellow monks due to his condition. (The ill Tissa Thera was forsaken by his fellow monks, due to the fact that, in the past, he had similarly abandoned other sick monks in need of medical care). When the Buddha discovered his plight, Buddha himself personally boiled water and washed Tissa with Buddha’s own hands, cleaned his garments, and offered him comfort. Following this act of compassion, the Buddha preached to Tissa, and he attained Arahantship before passing away shortly thereafter.</p>
        <p className="mt-5 h4 p-4">In this instance, the Buddha demonstrated that caring for the sick is an act of great merit, and in doing so, He set an example that would be followed by the lay community. Inspired by the Buddha’s compassion, the laity began to build wards and facilities for sick monks in large monasteries, ensuring that the Sangha would always receive the care they need. </p>
        <p className="mt-6 h4 p-4">By contributing to the Sangha Health Fund, you are helping to continue this noble tradition, supporting the health and spiritual well-being of the Sangha, and accumulating great merit. We are deeply grateful for your generosity and compassion in caring for the sick, in alignment with the Buddha’s teachings.</p>

        <p className="mt-5 h4 p-4"></p>
            <div className='btn-group2 mt-6'>
                <img src={imageTwo} alt="Right Top Image" width={300} />
                <img src={imageFour} alt="Right Top Image" width={300} />
            </div>

            <div className="p-4 mt-6 text-center">
            <div className="mt-6 calander-box align-item-center">
                    <div className="c-details text-left">
                        <h2 className='intro-text '>Futher More Details : </h2>
                        <p className="font-p mt-4">Monastery : 035608 0918 / 0459 729 738</p>
                        <p className="font-p">Mr Gamini : 0422 069 359</p>
                        <p className="font-p">WhatsApp : 0422 069 359</p>
                        <p className="font-p">E-mail : info@bvp.org.au</p>
                    </div>
                    <div className="d-button">
                  <img
          src={imageSix}
          alt="Right Top Image"
          width={300}
          id="healthFundReq"
         onClick={handleClick}
          className="curser-pointer"
        />
                    </div>
                </div>
                </div>

                <div className="bottom-box mt-6">
                <img src={imageThree} alt="bottom-image"  width={600} />
            </div>

        </div>
  )
}

export default HealthFounds